import { itemCheckStates } from '../constants';

function getItemCheckState(idToItem, selectableDescendantItemIds, selectedIds) {
  const map = new Map();

  idToItem.forEach((_item, itemId) => {
    const descendantIds = selectableDescendantItemIds.get(itemId);

    if (!descendantIds || descendantIds.length === 0) {
      map.set(
        itemId,
        selectedIds.has(itemId) ? itemCheckStates.CHECKED : itemCheckStates.UNCHECKED
      );
      return;
    }

    const someChecked = descendantIds.some((id) => selectedIds.has(id));

    if (!someChecked) {
      map.set(itemId, itemCheckStates.UNCHECKED);
      return;
    }

    const allChecked = descendantIds.every((id) => selectedIds.has(id));

    map.set(itemId, allChecked ? itemCheckStates.CHECKED : itemCheckStates.INDETERMINATE);
  });

  return map;
}

export default getItemCheckState;
